<template>
  <section>
    <span
      class="text-weight-bolder"
      style="display: block; font-size: 16px; color: #21324a; margin-top: 20px"
      >Ferramentas</span
    >
    <q-table
      style="max-height: 500px"
      flat
      table-header-class="bg-accent text-width-bold"
      :rows="rows"
      :loading="disable"
      :columns="columns"
      class="tabela-tamanho-fixo my-sticky-header-table"
      row-key="name"
      color="primary"
      :pagination="pagination"
      hide-bottom
      dense
      :rows-per-page-label="'Linhas Por Página'"
      :rows-per-page-options="[10, 25, 50, 100]"
      :filter="filtrar"
    >
      <template v-slot:top-left>
        <span style="display: block; margin-left: -15px; color: #21324a"
          >Ferramentas Vinculadas ao usuário.</span
        >
      </template>
      <template v-slot:top-right>
        <q-input
          rounded
          outlined
          dense
          debounce="300"
          v-model="filtrar"
          type="text"
          placeholder="Pesquisar"
        >
          <template v-slot:append>
            <q-icon name="search" />
          </template>
        </q-input>
      </template>

      <template #body-cell-remover="props">
        <q-td>
          <q-btn
            color="negative"
            icon="sym_o_delete"
            flat
            round
            @click="removerFerramenta(props.row.ferramenta_uuid)"
          />
        </q-td>
      </template>
    </q-table>
  </section>
</template>

<script setup>
import { ref, onMounted, computed, defineProps, watch } from "vue";
import { useStore } from "vuex";

import { useQuasar } from "quasar";

const props = defineProps({
  id: {
    type: Number,
  },
});

const userId = computed(() => props.id);

const columns = [
  {
    name: "nome_ferramenta",
    label: "Ferramenta",
    field: "nome_ferramenta",
    align: "left",
  },
  {
    name: "status_ferramenta",
    label: "Status Ferramenta",
    field: "status_ferramenta",
    align: "left",
  },
  {
    name: "nome_vendor",
    label: "Unidade",
    field: "nome_vendor",
    align: "left",
  },
  {
    name: "remover",
    label: "Remover",
    field: "remover",
    align: "left",
  },
];

const pagination = ref({
  sortBy: "desc",
  descending: false,
  page: 1,
  rowsPerPage: 15,
});
const rows = ref([]);
const disable = ref(true);
const filtrar = ref("");
const store = useStore();

const quasar = useQuasar();

const getFerramentas = async (page = 0, rowsPerPage = 1000) => {
  disable.value = true;

  try {
    let response = await store.dispatch("user/getFerramentas", {
      id: userId.value,
      page,
      per_page: rowsPerPage,
      nome_ferramenta: filtrar.value,
    });

    rows.value = response.data.result[0].ferramentas;

    disable.value = false;
  } catch (error) {
    console.log(error);
    quasar.notify({
      message: "Erro a o procurar dados",
      color: "negative",
      actions: [
        {
          label: "Fechar",
          color: "white",
          handler: () => {
            /* ... */
          },
        },
      ],
    });
  }
};

onMounted(getFerramentas);

const removerFerramenta = async (ferramenta_uuid) => {
  try {
    await store.dispatch("user/removerFerramenta", {
      id: userId.value,
      ferramenta_uuid,
    });

    quasar.notify({
      message: "Grupo removido com sucesoo",
      color: "positive",
      actions: [
        {
          label: "Fechar",
          color: "white",
          handler: () => {
            /* ... */
          },
        },
      ],
    });
    getFerramentas();
  } catch (error) {
    quasar.notify({
      message: "Erro ao remover grupo",
      color: "positive",
      actions: [
        {
          label: "Fechar",
          color: "white",
          handler: () => {
            /* ... */
          },
        },
      ],
    });
  }

  watch(
    () => filtrar.value,
    () => {
      getFerramentas();
    }
  );
};
</script>
<style lang="sass">
.my-sticky-header-table
  /* height or max-height is important */
  max-height: 500px


  thead tr:first-child th
    /* bg color is important for th; just specify one */
    background-color: #EEF3FE

  thead tr th
    position: sticky
    z-index: 1
  thead tr:first-child th
    top: 0

  /* this is when the loading indicator appears */
  &.q-table--loading thead tr:last-child th
    /* height of all previous header rows */
    top: 48px

  /* prevent scrolling behind sticky top row on focus */
  tbody
    /* height of all previous header rows */
    scroll-margin-top: 48px
</style>
